import React from 'react';
import { Navigate } from 'react-router-dom';
import { readUserInfo } from '../../services/pageAccess';
import { isAdminTabRole } from '../../services/managementService';

const AdminRoute = ({ children }) => {
  if (!isAdminTabRole(readUserInfo().Role)) {
    return <Navigate to="/home" replace />;
  }
  return children;
};

export default AdminRoute;
